import { Component, type ErrorInfo, type ReactNode } from 'react';
import { reportError } from '@/lib/monitoring';

interface State {
  error: Error | null;
}

/** Last-resort boundary: logs to monitoring and offers a reload. */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    reportError(error, { componentStack: info.componentStack });
  }

  override render() {
    if (!this.state.error) return this.props.children;
    return (
      <div
        role="alert"
        className="mx-auto mt-16 max-w-md rounded-2xl border border-line bg-panel p-6 text-center"
      >
        <h1 className="mb-2 text-xl font-bold">משהו השתבש · Something went wrong</h1>
        <p className="mb-4 break-words text-sm text-muted">{this.state.error.message}</p>
        <button
          className="rounded-lg bg-brand px-4 py-2 font-bold text-brand-ink"
          onClick={() => window.location.reload()}
        >
          רענון · Reload
        </button>
      </div>
    );
  }
}
